import { render, staticRenderFns } from "./CreditoOperadoras.vue?vue&type=template&id=47b8f890&"
import script from "./CreditoOperadoras.vue?vue&type=script&lang=js&"
export * from "./CreditoOperadoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports